<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">分享模板</div>

    <div class="search-wrapper">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="状态">
          <el-select v-model="queryForm.status" style="width: 160px">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="免费类型">
          <el-select v-model="queryForm.useType" style="width: 160px">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in useTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button @click="clickReset">重置</el-button>
      <el-button type="primary" @click="clickQuery">查询</el-button>
    </div>

    <!-- <div class="action-wrapper">
      <el-button type="primary" @click="clickAdd">+ 新建模板</el-button>
    </div> -->

    <div class="content-wrapper">
      <el-table
        border
        :data="listData"
        style="width: 100%"
        @sort-change="handleSortChange"
      >
        <el-table-column
          align="center"
          label="id"
          prop="id"
          width="80"
        ></el-table-column>
        <el-table-column
          align="center"
          label="模板名称"
          prop="name"
          min-width="160"
        ></el-table-column>
        <el-table-column align="center" label="模板图片" width="110">
          <template scope="{ row }">
            <img
              v-if="row.imageUrl"
              class="template-img"
              :src="row.imageUrl"
              alt="模板图片"
              @click="previewImage(row.imageUrl)"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="模板类型" width="100">
          <template scope="{ row }">{{
            getTemplateTypeText(row.templateType)
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          label="展示排序"
          prop="sort"
          width="120"
          sortable="custom"
        ></el-table-column>
        <el-table-column align="center" label="免费类型" width="110">
          <template scope="{ row }">{{ getUseTypeText(row.useType) }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          label="创建时间"
          prop="createAt"
          min-width="165"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          align="center"
          label="最近操作时间"
          prop="updateAt"
          min-width="165"
          sortable="custom"
        ></el-table-column>
        <el-table-column align="center" label="状态" width="90">
          <template scope="{ row }">
            <span :class="getStatusClass(row.status)">{{
              getStatusText(row.status)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="140" fixed="right">
          <template scope="{ row }">
            <el-button
              type="text"
              style="color: #409eff"
              v-if="row.isSystemPreset != 1"
              @click="clickEdit(row)"
              >编辑</el-button
            >
            <el-button
              v-if="row.status === 1"
              type="text"
              style="color: #409eff"
              @click="clickToggleStatus(row, 0)"
              >停用</el-button
            >
            <el-button
              v-else
              type="text"
              style="color: #409eff"
              @click="clickToggleStatus(row, 1)"
              >启用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        v-show="total > 0"
        layout="total, prev, pager, next, jumper"
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="changeCurrentPage"
      >
      </el-pagination>
    </div>

    <!-- 大图预览：1.4 的 el-dialog 不支持 v-model，必须用 visible.sync -->
    <el-dialog
      title="模板图片"
      :visible.sync="previewVisible"
      width="520px"
      :modal-append-to-body="false"
    >
      <div class="preview-wrapper">
        <img :src="previewUrl" alt="模板图片" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTemplateTypeText,
  getUseTypeText,
  getStatusText,
  getOrderType,
  USE_TYPE_OPTIONS,
  STATUS_OPTIONS,
} from "./constants";

const LOG_TAG = "[分享模板]";
const LIST_URL = "/adminapi/v1/shareTemplate/list";
const CHANGE_URL = "/adminapi/v1/shareTemplate/change";
// 后端暂无 detail 接口，编辑时通过 sessionStorage 把整行数据带给详情页
const EDIT_ROW_KEY = "shareTemplateEditRow";

function buildQueryForm() {
  return {
    status: "",
    useType: "",
    pageNumber: 1,
    pageSize: 10,
    orderType: "",
  };
}

export default {
  name: "ShareTemplate",

  data() {
    return {
      loading: false,
      queryForm: buildQueryForm(),
      total: 0,
      listData: [],
      useTypeOptions: USE_TYPE_OPTIONS,
      statusOptions: STATUS_OPTIONS,

      previewVisible: false,
      previewUrl: "",
    };
  },

  mounted() {
    this.queryList();
  },

  methods: {
    getTemplateTypeText,
    getUseTypeText,
    getStatusText,

    getStatusClass(status) {
      return status === 1 ? "status-active" : "status-disabled";
    },

    queryList() {
      // 空字符串表示「不传查全部」，不参与提交
      const { status, useType, pageNumber, pageSize, orderType } =
        this.queryForm;
      const params = { pageNumber, pageSize };
      if (status !== "") params.status = status;
      if (useType !== "") params.useType = useType;
      if (orderType !== "") params.orderType = orderType;

      this.loading = true;
      this.$http({
        method: "GET",
        url: this.$util.domain + LIST_URL,
        params,
      })
        .then((res) => {
          const body = res.body || {};
          if (body.error === 10000) {
            const data = body.data || {};
            this.total = data.count || 0;
            this.listData = data.resModels || [];
          } else {
            this.$util.errorMsg(body.message || "查询失败");
            this.total = 0;
            this.listData = [];
          }
        })
        .catch((err) => {
          console.error(LOG_TAG, "查询列表失败", err);
          this.$util.errorMsg("查询列表失败");
          this.total = 0;
          this.listData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    clickQuery() {
      this.queryForm.pageNumber = 1;
      this.queryList();
    },

    clickReset() {
      const orderType = this.queryForm.orderType;
      this.queryForm = buildQueryForm();
      this.queryForm.orderType = orderType;
      this.queryList();
    },

    // 排序：sortable="custom"，order 为 ascending / descending / null
    handleSortChange({ prop, order }) {
      this.queryForm.orderType = getOrderType(prop, order);
      this.queryForm.pageNumber = 1;
      this.queryList();
    },

    changeCurrentPage(page) {
      this.queryForm.pageNumber = page;
      this.queryList();
    },

    clickAdd() {
      sessionStorage.removeItem(EDIT_ROW_KEY);
      this.$router.push({ path: "/yunying/user/share/template/detail" });
    },

    clickEdit(row) {
      sessionStorage.setItem(EDIT_ROW_KEY, JSON.stringify(row));
      this.$router.push({
        path: "/yunying/user/share/template/detail",
        query: { id: row.id },
      });
    },

    clickToggleStatus(row, nextStatus) {
      const actionText = nextStatus === 1 ? "启用" : "停用";
      this.$confirm(`确定要${actionText}「${row.name}」吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() =>
          this.$http({
            method: "GET",
            url: this.$util.domain + CHANGE_URL,
            params: { id: row.id, status: nextStatus },
          })
        )
        .then((res) => {
          const body = res.body || {};
          if (body.error === 10000) {
            this.$util.successMsg(`${actionText}成功`);
            this.queryList();
          } else {
            this.$util.errorMsg(body.message || `${actionText}失败`);
          }
        })
        .catch((err) => {
          // 取消/关闭确认框时不提示
          if (err === "cancel" || err === "close") return;
          console.error(LOG_TAG, actionText + "失败", err);
          this.$util.errorMsg(`${actionText}失败`);
        });
    },

    previewImage(url) {
      this.previewUrl = url;
      this.previewVisible = true;
    },
  },
};
</script>

<style scoped>
.template-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  cursor: pointer;
}

.preview-wrapper {
  text-align: center;
}

.preview-wrapper img {
  max-width: 100%;
}

/* 状态色（与 PlatformDecoration 保持一致，非全局样式，需在本页声明） */
.status-active {
  color: #67c23a;
}

.status-disabled {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// ShareTemplate.vue?0c6d0e6b